/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPanelDown: {
  name: 'panel-down';
  data: string;
} = {
  name: 'panel-down',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Zm14 11V5H5v9h14ZM5 16h14v3H5v-3Z" fill="currentColor"/></svg>`,
};
